module.exports = __webpack_public_path__ + "static/media/Activities relevant to client file.5b109556.png";